<template>
  <div>
    <div class="d-flex justify-content ml-2 align-items-center my-2">
      <button
        class="btn btn-sm rounded-circle p-25 cursor-pointer"
        :class="isDark ? 'btn-danger' : 'btn-primary'"
        @click="goBack()"
      >
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div
        class="ml-1 text-capitalize text-dark cursor-pointer goback-text"
        @click="goBack()"
      >
        {{ $t("maintenance.go_back") }}
      </div>
    </div>
    <!-- Table Container Card -->
    <b-card class="m-2" no-body>
      <b-card-header class="pb-50">
        <h5 class="text-capitalize">
          <span v-if="!isUpdating">{{ $t("maintenance.create_template") }}</span>
          <span v-else>{{ $t("maintenance.update_template") }}</span>
        </h5>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="refFormObserver">
          <div class="m-2">
            <b-row>
              <!-- Per Page -->
              <b-col cols="12" md="8">
                <b-row>
                  <b-col class="mb-1 mb-md-0">
                    <validation-provider
                      #default="validationContext"
                      name="Template name"
                      rules="required"
                    >
                      <label class="d-block">
                        {{ $t("maintenance.template_name") }}
                      </label>
                      <b-form-input
                        v-model="templateName"
                        class="d-inline-block mr-1"
                        :placeholder="$t('maintenance.template_name')"
                      />
                      <b-form-invalid-feedback
                        :state="getValidationState(validationContext)"
                      >
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-col>

                  <b-col class="mb-1 mb-md-0"> </b-col>
                  <b-col cols="2" class="mb-1 mb-md-0"> </b-col>
                </b-row>
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="d-flex flex-column align-items-end justify-content-end mb-1 mb-md-0"
              >
                <div>
                  <!-- Add new item -->
                  <b-button class="mr-1" variant="primary" @click="addItem()">
                    <span class="text-nowrap text-capitalize">
                      {{ $t("maintenance.add_new_field") }}
                    </span>
                  </b-button>
                  <!-- Save changes -->
                  <b-button variant="success" @click="save()" :disabled="!isValid">
                    <span class="text-nowrap text-capitalize">
                      {{ $t("layout_builder.btns.save") }}
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </validation-observer>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <div class="w-100">
                <div class="">
                  <template-builder :items.sync="items" :is-valid.sync="isValid" />
                  <!-- <div v-else>
                    <p class="text-center">
                      {{ $t("maintenance.add_new_fields") }}
                    </p>
                  </div> -->
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormCheckbox,
  BFormInvalidFeedback,
} from "bootstrap-vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import useTemplateBuilderConfig from "./useTemplateBuilderConfig";
import store from "@/store";
import { computed } from "@vue/composition-api";
import TemplateBuilder from "@/components/TemplateBuilder";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormCheckbox,
    BFormInvalidFeedback,
    vSelect,
    TemplateBuilder,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  setup(_, context) {
    return {
      goBack: () => context.root.$router.push({ name: 'maintenanceTemplates' }),
      isDark: computed(() => store.state.appConfig.layout.skin === "dark"),

      ...useTemplateBuilderConfig(),
    };
  },
};
</script>

<style lang="scss" scoped>
.grid-stack {
  width: 100%;
  border: 2px dashed rgb(190, 190, 190);

  .gs-item {
    $gridstack-columns: 12;
    @for $i from 1 through $gridstack-columns {
      &[gs-w="#{$i}"] {
        width: (100% / $gridstack-columns) * $i !important;
      }
      &[gs-x="#{$i}"] {
        left: (100% / $gridstack-columns) * $i !important;
      }
      &.grid-stack-item[gs-min-w="#{$i}"] {
        min-width: (100% / $gridstack-columns) * $i !important;
      }
      &.grid-stack-item[gs-max-w="#{$i}"] {
        max-width: (100% / $gridstack-columns) * $i !important;
      }
    }
  }
}
.arrow-icon {
  font-size: 12px;
}
.goback-text {
  position: relative;
  top: 0.1rem;
  margin-left: 0.5rem !important;
}
</style>
